import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http.service';
import { Ability } from '@app/features/admin/settings/permission/permission.constants';
import { Permission } from '@app/features/admin/settings/permission/permission.types';
import { Profile } from '@app/layout/common/profile/state/profile.types';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsServices {
  public static readonly API: string = `${environment.PROJECT_API}/admin-group/cloud/roles`;

  constructor(private _httpClient: HttpService) {}

  getUserPermissions(_role: number): Observable<Permission> {
    return this._httpClient
      .get<{
        data: Permission;
      }>(`${SettingsServices.API}/permissions`, {})
      .pipe(map((permission) => permission?.data));
  }

  getPermissions(role: number): Observable<Permission> {
    return this._httpClient
      .get<{
        data: Permission;
      }>(`${SettingsServices.API}/${role}/permissions`, {})
      .pipe(map((permission) => permission?.data));
  }

  updatePermission(role: number, permission: any): Observable<any> {
    return this._httpClient
      .put<{
        data: any;
      }>(`${SettingsServices.API}/${role}/permissions/bulk`, permission, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  updateLandingPage(role: number, page: string): Observable<any> {
    return this._httpClient
      .put<{ data: any }>(`${environment.PROJECT_API}/admin-group/roles/${role}`, page, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  copyPermissions(role_id: number, body: string): Observable<any> {
    return this._httpClient
      .post<{
        data: any;
      }>(`${SettingsServices.API}/${role_id}/permissions/copy`, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  addPermission(role_id: number, body: string): Observable<any> {
    return this._httpClient
      .post<{
        data: any;
      }>(`${SettingsServices.API}/${role_id}/permissions`, body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  removePermission(role_id: number, body: string): Observable<any> {
    return this._httpClient
      .delete<{
        data: any;
      }>(`${SettingsServices.API}/${role_id}/permissions`, {
        body: body,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  getAbilities(categoryID: number): Observable<Ability[]> {
    const url = categoryID
      ? `${environment.PROJECT_API}/admin-group/cloud/meta/roles/abilities?category_id=${categoryID}`
      : `${environment.PROJECT_API}/admin-group/cloud/meta/roles/abilities`;
    return this._httpClient.get<{ data: Ability[] }>(url).pipe(map((response) => response.data));
  }

  updateBulkStorePermission(role: number, permission: any): Observable<any> {
    return this._httpClient
      .put<{
        data: any;
      }>(`${SettingsServices.API}/${role}/permissions/bulkStore`, permission, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;'
        }
      })
      .pipe(map((response) => response.data));
  }

  getSecurity(): Observable<Profile> {
    return this._httpClient
      .get<{
        data: Profile;
      }>(`${environment.AUTH_API}/web/auth/user/password/security`, {})
      .pipe(map((security) => security.data));
  }

  getUserInfor() {
    return this._httpClient
      .get<{
        data: Profile;
      }>(`${environment.PROJECT_API}/user/info`, {})
      .pipe(map((userInfor) => userInfor.data));
  }
}
